import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36575699"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lcts-card-graphic-table-main" }
const _hoisted_2 = { class: "lcts-card-graphic-table-card-info" }
const _hoisted_3 = { class: "lcts-card-graphic-table-title-wrapper" }
const _hoisted_4 = { class: "lcts-card-graphic-table-title" }
const _hoisted_5 = { class: "lcts-card-graphic-table-description" }
const _hoisted_6 = { class: "lcts-card-graphic-table-chart" }
const _hoisted_7 = { class: "lcts-card-graphic-table-row-label" }
const _hoisted_8 = ["title"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "vertical-line-1" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "vertical-line-2" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "vertical-line-3" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "vertical-line-4" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Baixo ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Médio ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Alto ", -1))
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "lcts-card-graphic-table-card",
      style: _normalizeStyle({ 'min-height': _ctx.heightTable + '!important' })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.titleTable), 1),
          _createElementVNode("span", {
            class: "lcts-card-graphic-table-circle",
            style: _normalizeStyle({ backgroundColor: _ctx.circleColor })
          }, null, 4)
        ]),
        _createElementVNode("span", _hoisted_5, [
          _createElementVNode("label", null, _toDisplayString(_ctx.descriptionHighlightedTable), 1),
          _createTextVNode(_toDisplayString(_ctx.descriptionTable), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.values, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "lcts-card-graphic-table-row",
              key: item.class
            }, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.class), 1),
              _createElementVNode("div", {
                class: "lcts-card-graphic-table-row-bar",
                "data-toggle": "tooltip",
                "data-placement": "top",
                title: _ctx.formatNumber(item.value, 1),
                style: _normalizeStyle({ backgroundColor: _ctx.barColorBackground })
              }, [
                _createElementVNode("div", {
                  class: "lcts-card-graphic-table-bar-value",
                  style: _normalizeStyle({ width: item.value + '%', backgroundColor: _ctx.barColor })
                }, null, 4)
              ], 12, _hoisted_8)
            ]))
          }), 128)),
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _hoisted_12
        ]),
        _createElementVNode("div", {
          class: "lcts-card-graphic-table-footer",
          style: _normalizeStyle({ marginTop: _ctx.marginTopFooter + '!important' })
        }, _hoisted_16, 4)
      ])
    ], 4)
  ]))
}